module.exports = __webpack_public_path__ + "static/media/3.7b9c5314.jpg";